<template>
  <div class="list-wrapper">
    <h1>Überblick</h1>
    <div v-if="loading">
      Lade ...
    </div>
    <div v-else>
      <ol class="entry-list" :start="rageStart">
        <li v-for="entry in overview.entries" :key="entry._id">
          <router-link :to="{ name: 'entry', params: { id: entry._id }}">
            <h2>{{ entry.name }}</h2>
          </router-link>
            <p>{{ entry.description }}</p>
        </li>
      </ol>
      <div class="pager" v-if="validPage">
        <router-link v-if="hasPrevOverviewPage" class="button" :to="{ name: 'sk-overview', query: { page: currentPage - 1 }}">
          Zurück
        </router-link>
        <p :class="currentPageClass">Seite {{ currentPage }} von {{ maxPage }}<br>Insgesamt {{ overview.total }} Einträge</p>
        <router-link v-if="hasNextOverviewPage" class="button" :to="{ name: 'sk-overview', query: { page: currentPage + 1 }}">
          Weiter
        </router-link>
      </div>
      <p v-else>
        Ungültige Seite!
      </p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from "vuex";

  const {siteName} = STADTKATALOG_CONFIG;

  export default {
    name: "sk-overview",
    data () {
      return {
        loading: true
      }
    },
    computed: {
      ...mapState([
        "overview"
      ]),
      ...mapGetters([
        "hasNextOverviewPage",
        "hasPrevOverviewPage"
      ]),
      rageStart() {
        return (this.overview.page * this.overview.size) + 1;
      },
      rangeEnd() {
        return Math.min(this.overview.total, (this.overview.page * this.overview.size) + this.overview.size);
      },
      currentPage() {
        return this.overview.page + 1;
      },
      validPage() {
        return this.overview.page >= 0 && this.rageStart <= this.overview.total;
      },
      maxPage() {
        return Math.ceil(this.overview.total / this.overview.size);
      },
      currentPageClass() {
        if (this.overview.page === 0) {
          return "first-page";
        } else if (!this.hasNextOverviewPage) {
          return "last-page";
        }

        return "normal-page";
      }
    },
    watch: {
      $route() {
        this.setPage();
        this.loading = true;
        this.$store.dispatch("updateOverview")
          .then(() => {
            this.loading = false;
          });
      }
    },
    methods: {
      setPage() {
        if (this.$route.query.page) {
          let pageCandidate = parseInt(this.$route.query.page, 10);
          if (!isNaN(pageCandidate) && pageCandidate > 0) {
            this.overview.page = pageCandidate - 1;
          } else {
            this.$router.replace({ name: "sk-overview" });
          }
        } else {
          this.overview.page = 0;
        }
      }
    },
    created() {
      document.title = "Überblick - " + siteName;

      this.setPage();
      this.loading = true;
      this.$store.dispatch("updateOverview")
        .then(() => {
          this.loading = false;
        });
    }
  }
</script>

<style lang="scss" scoped>
  @import '~SiteVariables';

  .entry-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 0;
      margin: 1.2rem 0;
    }

    a {
      display: block;
      color: inherit;
      text-decoration: none;
    }

    h2 {
      font-size: 1.1875rem;
      display: inline;
      margin: 0;
      color: $link-search-result-color;
      font-weight: 700;
      text-decoration: underline;
    }

    p {
      margin: 0.1875rem 0 0 0;
      font-size: 1rem;
      line-height: 1.375rem;
    }
  }

  .pager {
    $button-width: 5.5rem;

    display: flex;
    align-items: center;

    a {
      flex: 1 1 auto;
      max-width: $button-width;
      text-align: center;
    }

    p {
      flex: 1 1 auto;
      margin: 0;
      text-align: center;

      font-size: 1rem;
      line-height: 1.375rem;

      &.first-page {
        padding-left: $button-width;
      }

      &.last-page {
        padding-right: $button-width;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StadtKatalogOverview.vue